import { FC, ReactElement, ReactNode } from 'react';
import { Dropdown, Button } from 'antd';
import classNames from 'classnames';

import { ReactComponent as Arrow } from 'assets/icons/arrow-select.svg';

import './index.scss';

type DropDownComponentProps = {
	label: string | ReactElement;
	isTable?: boolean;
	className?: string;
	trigger?: 'click' | 'hover' | 'contextMenu';
	placement?:
		| 'bottomRight'
		| 'topLeft'
		| 'topCenter'
		| 'topRight'
		| 'bottomLeft'
		| 'top'
		| 'bottom';
	overlayClassName?: string;
	destroyPopupOnHide?: boolean;
	dropdownRender: () => ReactNode;
};

export const DropDownComponent: FC<DropDownComponentProps> = ({
	label,
	isTable,
	className,
	trigger = 'click',
	placement = 'bottomRight',
	overlayClassName,
	destroyPopupOnHide,
	dropdownRender,
}) => {
	return (
		<Dropdown
			overlayClassName={overlayClassName}
			placement={placement}
			dropdownRender={dropdownRender}
			trigger={[trigger]}
			className={classNames('dropdown', { [`${className}`]: className })}
			destroyPopupOnHide={destroyPopupOnHide}
		>
			<Button aria-label="dropdown button">
				{label} {!isTable && <Arrow />}
			</Button>
		</Dropdown>
	);
};
